module.exports = __webpack_public_path__ + "img/tu5.cb7ef894.png";